import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v4-mini';

import { ProjectPage } from '$/pages/DashboardPages/pages/Projects';
import { useProjectModal } from '$/pages/DashboardPages/pages/Projects/hooks/useProjectModal';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';
import { useProjectStore } from '$/stores/useProjectStore';

export const ProjectsRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/projects',
  component: ProjectPage,
  validateSearch: (search) =>
    z.object({ folderId: z.optional(z.string()) }).parse(search),
  onLeave: () => {
    useProjectModal.getState().onClose();
  },
  onEnter: async () => {
    await useProjectStore.getState().refetchProjects();
  },
});
